import Vue from 'vue';
import App from './App.vue';
import router from './router';
//import store from './store';
import store from '@/common/store';
import { ROOT_CHECK_AUTH } from '@common/lib/auth/store/types';
import {
  ROOT_SET_APPINFO,
  ROOT_FETCH_APPINFO,
  ROOT_APPLOADED,
} from '@common/store/modules/common/types';
import { ROOT_UPDATE_CURRENT_AREA } from '@common/store/modules/user/types';
import {
  getDeviceInfo,
  syncDeviceInfo,
  hideIntro,
  nativeDeviceInfo,
  // initLocation,
  isApp,
  nativeLocation,
  sleep,
} from '@common/lib/common/utils';
import ApiService from '@common/lib/api/api.service';
import { load as loadI18n, default_locale } from '@common/lib/i18n';
import Fragment from 'vue-fragment';
import VueCountdown from '@chenfengyuan/vue-countdown';
import 'vue2-animate/dist/vue2-animate.min.css';
import VueScrollTo from 'vue-scrollto';
import VueGeolocationApi from './plugins/geolocation';
//import VueGeolocationApi from 'vue-geolocation-api';
import VuePaginate from './plugins/paginate';
import VueToasted from './plugins/toasted';
import PinchZoom from 'vue-pinch-zoom';
import VueToast from './plugins/toast-notification';
import VueKeepScrollPosition from 'vue-keep-scroll-position';
// import '@/assets/front/css/common.scss';
// import '@/assets/front/css/style.scss';
// import '@/assets/font.css';
import '@/assets/front/css/main.scss';
import VueSkeletonLoader from 'skeleton-loader-vue';
import VueGtag from 'vue-gtag';
import Vuelidate from 'vuelidate';

import commConfig from '@common/config';
Vue.use(Vuelidate);

Vue.config.productionTip = false;
Vue.use(Fragment.Plugin);
Vue.use(VueScrollTo);
Vue.use(VueKeepScrollPosition);

Vue.component(VueCountdown.name, VueCountdown);
Vue.component('pinch-zoom', PinchZoom);
Vue.component('vue-skeleton-loader', VueSkeletonLoader);

import vueMoment from 'vue-moment';
import moment from 'moment';
moment.locale('ko');
Vue.use(vueMoment, { moment });

window.Kakao.init(commConfig.kakaoAppKey);
// console.log('isInitialized :: {}', window.Kakao.isInitialized());

//Vue.use(VueGeolocationApi);

const isProd = process.env.NODE_ENV.indexOf('production') >= 0;
// const isProd = process.env.NODE_ENV.indexOf('development') >= 0;
if (isProd) {
  Vue.use(
    VueGtag,
    {
      config: { id: 'G-C5BMBQWJ1V' },
    },
    router,
  );
}

//get fbToken
getDeviceInfo();
//nativeDeviceInfo();

loadI18n('customer', default_locale).then(async i18n => {
  import('@common/plugins/vee-validate');
  ApiService.init();

  store.dispatch(ROOT_SET_APPINFO, {
    appType: window.$bridge.deviceInfo.appType,
    device: window.$bridge.deviceInfo.device,
    uuid: window.$bridge.deviceInfo.uuid,
    appVersion: window.$bridge.deviceInfo.appVersion,
    osVersion: window.$bridge.deviceInfo.osVersion,
    fbToken: window.$bridge.deviceInfo.registrationKey,
  });

  try {
    const appinfo = await store.dispatch(ROOT_FETCH_APPINFO);
    //console.log(appinfo);
    await store.dispatch(ROOT_CHECK_AUTH);
    const vue = startApp(i18n);
    store.commit(ROOT_APPLOADED);
    updateCurrentArea(vue);
    syncDeviceInfo();
    setTimeout(() => {
      window.$bridge.pageLoaded = true;
    }, 5000);
  } catch (e) {
    //alert(e);
  }
});

async function updateCurrentArea(vue) {
  let latitude = 0;
  let longitude = 0;
  const currentUser = store.getters['auth/CURRENT_USER'];
  if (currentUser && currentUser.id) {
    if (!isApp()) {
      //console.log(vue.$geolocation);
      if (vue.$geolocation.checkSupport()) {
        const currentPosition = await vue.$geolocation.getCurrentPosition();
        if (currentPosition) {
          latitude = currentPosition.coords.latitude;
          longitude = currentPosition.coords.longitude;
        }
      }
    } else {
      nativeLocation();
      await sleep(1000);
      if (window.$bridge.location.code) {
        if (window.$bridge.location.code === '1') {
          latitude = window.$bridge.location.latitude;
          longitude = window.$bridge.location.longitude;
        }
      }
    }
    if (latitude !== 0 && longitude !== 0) {
      await store.dispatch(ROOT_UPDATE_CURRENT_AREA, {
        latitude: latitude,
        longitude: longitude,
      });
    }
  }
}

function startApp(i18n) {
  const main = new Vue({
    i18n,
    store,
    router,
    render: h => h(App),
  });

  main.$mount('#app');
  return main;
}
